/**
 * DocumentViewerColumn
 *
 * Wrapper component that renders the appropriate document viewer
 * (PDF or Image) based on the document type.
 */

import type { DocumentColumnConfig } from './types';
import { PDFDocumentViewer } from '../viewers/PDFDocumentViewer';
import { ImageDocumentViewer } from '../viewers/ImageDocumentViewer';

interface DocumentViewerColumnProps {
  config: DocumentColumnConfig;
}

export function DocumentViewerColumn({ config }: DocumentViewerColumnProps) {
  if (config.documentType === 'pdf') {
    return (
      <div className="h-full w-full overflow-hidden">
        <PDFDocumentViewer
          columnId={config.id}
          url={config.documentUrl}
          citations={config.citations}
          citationFieldMap={config.citationFieldMap}
        />
      </div>
    );
  }

  if (config.documentType === 'image') {
    return (
      <div className="h-full w-full overflow-hidden">
        <ImageDocumentViewer
          columnId={config.id}
          url={config.documentUrl}
          citations={config.citations}
          citationFieldMap={config.citationFieldMap}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full w-full text-muted-foreground">
      Unsupported document type
    </div>
  );
}
